import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { AcdService } from 'src/app/services/dashboard.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  parentData: any = [];
  public show = false;
  public spinner = this.iconPacks.FaSpinner;
  public closeIcon = this.iconPacks.Faclose;
  plusicon = this.iconPacks.FaSearchPlus;
  public remainingCharacter = 0;
  public Inputvalue = "";
  public maxlength = 3500;
  public charachtersCount: number = 0;
  public counter: string = "";
  public expandedState = true;
  public btn1: string = "Job Plan / MWO Header";
  public btn2: string = "PM";
  public btn3: string = "EPL";
  private popupref: PopupRef | undefined;
  public anchorElement: any;
  public textboxElement: any;
  public expandCollapseContent(): void {
    this.expandedState = !this.expandedState;
  }
  constructor(private popupservice: PopupService, private iconPacks: EmdmIcons, public router: Router, private acdservice: AcdService) { }
  
  @HostListener('document:keydown.escape', ['$event1']) handleEscapeEvent(event: KeyboardEvent) {
    this.show = false;
  }

  searchType = "JobPlan";

  searchForm: FormGroup = new FormGroup({
    tag: new FormControl(''),
    mwo: new FormControl(''),
    mwoProbDesc: new FormControl(''),
    jobPlanNumber: new FormControl(''),
    eplLong: new FormControl(''),
    eplShort: new FormControl(''),
    item: new FormControl(''),
  });

  isPMShow = false;
  isPMProbDescShow = false;
  isJPNumberShow = false;
  isActivePMWOShow = false;
  isMWIShow = false;
  isEPLShow = false;
  btnActionName = 'Search Job Plan / MWO History';

  iconPack = EMDMICONS;

  public openPopupCheck(anchor: HTMLElement, textbox: any, formControlSelected: any): void {
    this.anchorElement = anchor;
    this.textboxElement = textbox;
    this.show = !this.show;
  }
  public closePopup(): void {
    this.show = false;
  }

  ngOnInit() {
    this.remainingCharacter = this.maxlength;
    this.counter = `${this.remainingCharacter}`;

    this.searchFieldShowHide();
  }

  OnKeyDown(event: any) {
    if (event.key === 'Enter' && this.expandedState && !this.isDataChanged()) {
      this.historyApiClick();
    }
  }

  searchTypeChanged(searchType: string) {
    this.searchType = searchType;
    this.btnActionName = searchType == "JobPlan" ? 'Search Job Plan / MWO History' : searchType == "PM" ? 'Search PM History' : searchType == "EPL" ? 'Search EPL History' : '';
    this.searchFieldShowHide();
  }

  searchFieldShowHide() {
    this.isPMShow = this.searchType == 'JobPlan' || this.searchType == 'PM';
    this.isPMProbDescShow = this.isPMShow;
    this.isJPNumberShow = this.searchType == 'JobPlan' || this.searchType == 'MWO';
    this.isActivePMWOShow = this.isJPNumberShow;
    this.isMWIShow = this.searchType == 'JobPlan';
    this.isEPLShow = this.searchType == 'EPL'
  }

  onValueChange(ev: string) {
    this.Inputvalue = ev;
    this.charachtersCount = ev.length;
    this.remainingCharacter = this.maxlength - this.charachtersCount;
    this.counter = `${this.remainingCharacter}`;
  }

  public popupSubmit() {
    const output = this.Inputvalue.replace(/\n/g, ',');
    this.textboxElement.value = output;
    this.show = false;
    this.Inputvalue = '';
  }

  isDataChanged() {
    const controls = this.searchForm.controls;
    for (let controlNames in controls) {
      if (controls[controlNames].value != "") {
        return false;
      }
    }
    return true;
  }

  gridData : any = [];
  
  historyApiClick(){
    let payload = this.searchForm.value;
    payload.searchType = this.searchType;
    this.acdservice.getHistorySearch(payload).subscribe((data)=>{
      this.gridData = data
    })
  }
}
